import {
  initializeDataVersion,
  type GameToolVersionFetcher,
} from "@huyafed/gametool-data-runtime";
import type { DataRuntimeConfig } from "../config/dataRuntime";

export interface TrendDataVersionContext {
  version: string;
  dataRoot: string;
}

export type { GameToolVersionFetcher };

export async function initializeTrendDataVersion(
  config: DataRuntimeConfig,
  location: Pick<Location, "search" | "hash">,
  getVersion: GameToolVersionFetcher,
): Promise<TrendDataVersionContext> {
  const context = await initializeDataVersion(config, location, getVersion);

  return {
    version: context.version,
    dataRoot: context.versionRoot,
  };
}
